export default __webpack_public_path__ + "static/media/04_chat 2.10913afc.gif";